import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-upperclub',
  templateUrl: './upperclub.component.html',
  styleUrls: ['./upperclub.component.scss']
})
export class UpperclubComponent implements OnInit {

  public show:boolean;
  public show_mobile:boolean;
  public show_description:boolean;

  @Input() show_content:boolean;
  @Input() is_active:boolean;
  @Output() x = new EventEmitter();

  constructor(){ 
  }

  ngOnInit():void{
  }

  showContent(){
    this.show = true;
    this.x.emit({})
  }

  showMobileContent(){
    this.show_mobile = !this.show_mobile;
  }

  toggleClass(number:any) {
    this["show_description" + number]  = !this["show_description" + number];
  }

}
